import React from 'react'
import WeakData from './WeakData'
import Today from './Today'
import './section.css'

const Section = () => {
  return (
    <div>
        <WeakData />
        <Today />
    </div>
  )
}

export default Section